import fetch from './fetch'
export const clone = (obj) => JSON.parse(JSON.stringify(obj))
export const uuid = function () {
  let s = []
  let hexDigits = '0123456789abcdef'
  for (var i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
  }
  s[14] = '4'
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1)
  s[8] = s[13] = s[18] = s[23] = '-'
  let uuid = s.join('')
  return uuid
}
// 加载 @ 变量数据源
export const loadMentionSources = {
  // 加载策略下所有变量源
  doLoadAllSources: async function (strategyId) {
    let variableSources = []
    await fetch.get('/common/mentionSources/' + strategyId).then(res => {
      if (res && res.code === '200') {
        variableSources = res.data
      } else {
        console.warn('加载@变量数据源失败：', res.message)
      }
    }).catch(e => {
      console.error('加载@变量数据源异常：', e)
    })
    return variableSources
  },
  // 加载策略下所有变量源 并且排除当前组件的输出
  doLoadSourcesExcludeCurrentModelOutput: async function (strategyId, strategyItemCode) {
    let variableSources = await loadMentionSources.doLoadAllSources(strategyId)
    if (variableSources.length > 0 && strategyItemCode && strategyItemCode !== '') {
      let matchCode = 'm_' + strategyItemCode + '_'
      variableSources = variableSources.filter(function (source) {
        return !(source.refType === 2 && source.name.startsWith(matchCode))
      })
    }
    return variableSources
  }
}



// WEBPACK FOOTER //
// ./src/utils/common.js